import { string } from 'yup';
import YCApi from './ycApi';
import Blokkendoos from './blokkendoos';

const EMAIL_KEY = 'email';

export default class EmailUniquenessChecker {
  constructor() {
    this.api = new YCApi();
    this.blokkendoos = new Blokkendoos();
    this.cache = {};
    this.isUniqueResp = false;
  }

  _emailAlreadyChecked(email) {
    const currentEmail = this.cache[EMAIL_KEY];
    return !!(currentEmail && currentEmail === email);
  }

  _cacheEmail(nextEmail, isUnique) {
    this.cache[EMAIL_KEY] = nextEmail;
    this.isUniqueResp = isUnique;
  }

  _isValidEmail(email) {
    return string().required().email().isValidSync(email);
  }

  isUnique(email) {
    const isEmailAlreadyChecked = this._emailAlreadyChecked(email);
    const isInvalidEmail = !this._isValidEmail(email);

    if (isInvalidEmail) {
      return Promise.resolve(true);
    }

    return isEmailAlreadyChecked
      ? Promise.resolve(this.isUniqueResp)
      : this.api.checkEmailUniqueness(email).then(({ data }) => {
          const isUnique = !data.present;
          this._cacheEmail(email, isUnique);

          return isUnique;
        });
  }

  assertUnique(email) {
    return this.isUnique(email).then(isUnique => {
      if (isUnique) return;
      this.blokkendoos.triggerCandidateLoginModal();
    });
  }
}
